export default {
  Textbox: 'textBox',
  Textarea: 'textArea',
  NumberInput: 'numberInput',
  Dropdown: 'dropDown',
  Checkbox: 'checkBox',
  Date: 'date',
  Time: 'time',
  DateTime: 'dateAndTime',
  SingleSelection: 'optionGroupSingleSelection',
  MultipleSelection: 'optionGroupMultipleSelection',
  Hyperlink: 'hyperlink',
  Paragraph: 'paragraph',
}
